import { IApplicationState } from '../../types/redux';

export function getNewbuildingReviewsCount(state: IApplicationState) {
  const {
    newbuilding: { reviewsCount },
  } = state;

  return reviewsCount;
}
